 import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { getUserRoleReq } from "../../service/branchService";
import { setBreadcrumbItems } from "../../store/actions";

const RolesPermissions = (props) => {
  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Roles & Permissions", link: "#" },
  ];

  const [adminRoles, setAdminRoles] = useState([]);
  const [clientRoles, setClientRoles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    props.setBreadcrumbItems("Roles & Permissions", breadcrumbItems);
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const adminData = await getUserRoleReq(true);
      const clientData = await getUserRoleReq(false);

      setAdminRoles(adminData?.payload?.roles ?? []);
      setClientRoles(clientData?.payload?.roles ?? []);
    } catch (err) {
      console.error("Failed to fetch roles:", err);
    }
  };

  const handleOptionClick = (action, role, isAdmin) => {
    const roleTitle = role ? role.title : "New";
    navigate(`/roles/${encodeURIComponent(roleTitle)}/${action.toLowerCase()}`, {
      state: { role, action, isAdmin },
    });
  };



  const renderTable = (title, roles) => (
    <Card className="role-card">
      <CardBody>
        <h4 className="table-title">{title}</h4>

        <div className="table-header">
          <span>Role</span>
          <span>Options</span>
        </div>

        {roles.length > 0 ? (
          roles.map((role) => (
            <div key={role._id} className="table-row">
              <span className="role-name">{role.title}</span>
              <div className="role-options">
                <button
                  onClick={() => handleOptionClick("view", role, title.includes("Admin"))}
                  className="option-btn view"
                >
                  View
                </button>
                <button
                  onClick={() => handleOptionClick("edit", role, title.includes("Admin"))}
                  className="option-btn edit"
                >
                  Edit
                </button>
              </div>
            </div>
          ))

        ) : (
          <p className="empty-text">No roles found.</p>
        )}
      </CardBody>
    </Card>
  );

  return (
    <div className="roles-page">
      <div className="create-button-container">
        <button
          onClick={() => handleOptionClick("create", null, true)}
          className="option-btn create"
        >
          <Add />Create
        </button>
      </div>
      <div className="roles-container">
        {renderTable("Admin Roles", adminRoles)}
        {renderTable("Client Roles", clientRoles)}
      </div>

      <style jsx>{`
        .roles-page {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .roles-container {
          display: flex;
          gap: 2rem;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
        }

        .role-card {
          flex: 1;
          min-width: 320px;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .create-button-container {
          display: flex;
          justify-content: flex-end;
          margin-top: 1rem;
        }
        .create-button-container button {
          background-color: #0053FF;
          color: white;
          border: none;
          border-radius: 5px;
          padding: 10px 20px;
        }

        .role-card:hover {
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
        }

        .table-title {
          font-weight: 600;
          font-size: 1.1rem;
          margin-bottom: 1rem;
          color: #1f2937;
        }

        .table-header {
          display: flex;
          justify-content: space-between;
          font-weight: 600;
          border-bottom: 1px solid #e5e7eb;
          padding-bottom: 0.5rem;
          color: #374151;
        }

        .table-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 0;
          border-bottom: 1px solid #f3f4f6;
          transition: background 0.15s ease;
        }

        .table-row:hover {
          background: #f9fafb;
        }

        .role-name {
          font-size: 0.95rem;
          font-weight: 500;
          color: #111827;
        }

        .role-options {
          display: flex;
          gap: 20px;
        }

        .option-btn {
          display: flex;
          align-items: center;
          gap: 0.3rem;
          font-size: 0.85rem;
          border: none;
          background: none;
          color: #0053FF;
          cursor: pointer;
          transition: color 0.2s ease;
          padding: 0;
        }

        .option-btn span {
          display: none;
        }

        @media (min-width: 640px) {
          .option-btn span {
            display: inline;
          }
        }

        .empty-text {
          text-align: center;
          color: #6b7280;
          padding: 1rem 0;
          font-size: 0.9rem;
        }

        @media (max-width: 768px) {
          .roles-page {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(RolesPermissions);
